import { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line no-restricted-imports -- Retained until the Townsquare router facade migration is completed; see VOLTPLAT-330.
import { RouteResource } from 'react-resource-router';

import { createRelayResource } from '@townsquare/relay-utils';

import OnboardingQuery, {
	type OnboardingQuery as OnboardingQueryType,
} from '../components/__generated__/OnboardingQuery.graphql';

export const onboardingResource: RouteResource<PreloadedQuery<OnboardingQueryType, Record<string, unknown>>> =
	createRelayResource<OnboardingQueryType>({
		getQuery: () => {
			return {
				query: OnboardingQuery,
			};
		},
	});
